module.exports = __webpack_public_path__ + "img/questionmark-diamond.2ac1d348.svg";